
import { mapState } from 'vuex'

export default {
  head() {
    return {
      title: this.$t('register'),
    }
  },

  computed: {
    ...mapState('global', ['registrationSettings']),
  },
}
